(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["np-about"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var script = document.currentScript;
    var root = script && script.closest ? script.closest('.shopify-section') : null;
    var scope = root || document;
    var els = scope.querySelectorAll('[data-count-to]');
    if (!els.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function fmt(n, decimals) {
      return decimals > 0 ? n.toFixed(decimals) : String(Math.round(n));
    }

    function animate(el) {
      if (el.dataset.counted === 'true') return;
      el.dataset.counted = 'true';
      var raw = el.getAttribute('data-count-to') || '0';
      var target = parseFloat(raw);
      if (isNaN(target)) {
        el.textContent = raw;
        return;
      }
      var decimals = (raw.split('.')[1] || '').length;
      if (reduce) {
        el.textContent = fmt(target, decimals);
        return;
      }
      var duration = 1200;
      var start = null;
      function step(ts) {
        if (start === null) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = fmt(target * eased, decimals);
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          el.textContent = fmt(target, decimals);
        }
      }
      requestAnimationFrame(step);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animate(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(animate);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
